import DateFormatResolver from 'resolvers/date-format.resolver';

const roundToTen = (value) => (Math.ceil(value / 10) * 10) || 10;

const spoofedCallsCountsLabel = 'Total number of spoofed calls';
const customersReceivingSpoofedCallsCountsLabel = 'Total number of unique number of Mobiles receiving the spoofed calls';

export default (data = [], granularity) => {
	const dateFormat = granularity === 'hour' ? 'hA' : 'DD MMM `YY';
	const customersReceivingSpoofedCallsCounts = [];
	const spoofedCallsCounts = [];
	const labels = [];
	let customersReceivingSpoofedCallsCountHighest = 0;
	let spoofedCallsCountHighest = 0;

	for (let i = 0; i < data.length; i += 1) {
		customersReceivingSpoofedCallsCounts.push(data[i].customersReceivingSpoofedCallsCount);
		spoofedCallsCounts.push(data[i].spoofedCallsCount);
		labels.push(DateFormatResolver.resolve(data[i].timeSlot, dateFormat));

		if (data[i].customersReceivingSpoofedCallsCount > customersReceivingSpoofedCallsCountHighest) {
			customersReceivingSpoofedCallsCountHighest = data[i].customersReceivingSpoofedCallsCount;
		}

		if (data[i].spoofedCallsCount > spoofedCallsCountHighest) {
			spoofedCallsCountHighest = data[i].spoofedCallsCount;
		}
	}

	return {
		data: {
			datasets: [
				{
					yAxisID: 'left',
					label: spoofedCallsCountsLabel,
					data: spoofedCallsCounts,
					backgroundColor: '#9728B2',
					order: 2,
				},
				{
					label: customersReceivingSpoofedCallsCountsLabel,
					data: customersReceivingSpoofedCallsCounts,
					type: 'line',
					borderColor: '#F79700',
					pointBackgroundColor: '#F79700',
					fill: false,
					lineTension: false,
					yAxisID: 'right',
					order: 1,
				},
			],
			labels,
		},
		options: {
			plugins: {
				datalabels: {
					display: false,
				},
			},
			responsive: true,
			maintainAspectRatio: false,
			legend: {
				display: false,
			},
			scales: {
				xAxes: [
					{
						barPercentage: 0.2,
						scaleShowGridLines: true,
						ticks: {
							fontColor: 'rgba(0, 0, 0, 0.2)',
							fontSize: 14,
						},
						gridLines: {
							display: false,
						},
					},
				],
				yAxes: [
					{
						id: 'left',
						ticks: {
							max: roundToTen(spoofedCallsCountHighest),
							min: 0,
							beginAtZero: true,
							fontColor: '#9728b2',
							fontSize: 14,
						},
						gridLines: {
							display: true,
							drawBorder: false,
							borderDash: [2, 2],
							color: 'rgba(0, 0, 0, 0.2)',
						},
					},
					{
						id: 'right',
						position: 'right',
						ticks: {
							max: roundToTen(customersReceivingSpoofedCallsCountHighest),
							min: 0,
							beginAtZero: true,
							fontColor: '#f79700',
							fontSize: 14,
						},
						gridLines: {
							display: false,
							drawBorder: false,
						},
					},
				],
			},
		},
		customLegend: [
			{
				color: '#9728b2',
				text: spoofedCallsCountsLabel,
			},
			{
				color: '#f79700',
				text: customersReceivingSpoofedCallsCountsLabel,
			},
		],
		type: 'bar',
		hasData: labels.length > 0,
	};
};
